<section *ngIf="processing">
    <h2>Processing...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
    </mat-progress-bar>
</section>

<mat-card *ngIf="generating">
    <span>{{generatingMessage}}...Please don't navigate away. Patience...</span><br />
    <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>


<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <h2 class="noMarginHeader">
            <mat-icon>link</mat-icon> Chain of Custody Letters - Generate Job
        </h2>
    </div>
</div>

<br />

<mat-tab-group dynamicHeight mat-align-tabs="begin" animationDuration="0ms" color="primary">
    <mat-tab label="Search">
        <form #form="ngForm" [formGroup]="retestService.searchForm" class="form-field-full" *ngIf="!generating">
            <div fxLayout="row wrap" class="matero-row">
                <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
                    <mat-card>
                        <div fxLayout="row wrap" fxLayoutGap="8px grid">
                            <div fxFlex="33.33" fxFlex.lt-sm="100">
                                <mat-form-field appearance="standard">
                                    <mat-label>Year</mat-label>
                                    <mat-select id="retestYear" name="retestYear" formControlName="retestYear">
                                        <mat-option value=""></mat-option>
                                        <mat-option *ngFor="let item of retestService.retestYears"
                                            [value]="item.id">{{item.id}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div fxFlex="33.33" fxFlex.lt-sm="100">
                                <mat-form-field appearance="standard">
                                    <mat-label>Quarter</mat-label>
                                    <mat-select id="retestQuarter" name="retestQuarter" formControlName="retestQuarter">
                                        <mat-option value=""></mat-option>
                                        <mat-option *ngFor="let item of retestService.retestQuarters" [value]="item.id">
                                            Quarter {{item.id}} (Q{{item.id}})
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div fxFlex="33.33" fxFlex.lt-sm="100">
                                <mat-form-field appearance="standard">
                                    <mat-label>Tier</mat-label>
                                    <mat-select id="tier" name="tier" formControlName="tier">
                                        <mat-option value=""></mat-option>
                                        <mat-option *ngFor="let item of retestService.tiers" [value]="item.id">Tier
                                            {{item.id}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="8px grid">
                            <div fxFlex="33.33" fxFlex.lt-sm="100">
                                <mat-form-field appearance="standard">
                                    <mat-label>Completed</mat-label>
                                    <mat-select id="isComplete" name="isComplete" formControlName="isComplete">
                                        <mat-option value=""></mat-option>
                                        <mat-option value="Yes">Yes</mat-option>
                                        <mat-option value="No">No</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            
                            <div fxFlex="33.33" fxFlex.lt-sm="100">
                                <mat-form-field appearance="standard">
                                    <mat-label>Well County</mat-label>
                                    <mat-select id="wellCounty" name="wellCounty" formControlName="wellCounty">
                                        <mat-option value=""></mat-option>
                                        <mat-option *ngFor="let item of sharedService.countyList" [value]="item">{{item}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>

            <!-- buttons -->
            <div fxLayout="row wrap" class="matero-row">
                <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
                    <mat-card>
                        &nbsp;&nbsp;
                        <button type="submit" id="submitButtonSearch" (click)="onSubmit()" mat-raised-button
                            color="primary" title="Search" [disabled]='processing'>Search</button>
                        &nbsp;&nbsp;
                        <button type="submit" id="submitButtonReset" (click)="reset()" mat-raised-button color="basic"
                            title="Clear" [disabled]='processing'>Clear</button>
                    </mat-card>
                </div>
            </div>
        </form>

        <!-- search results -->
        <mat-card [hidden]="!showResults || generating">

            <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                <strong class="noMarginHeader">Results ({{retestService.searchResultsCount}}) </strong>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <mat-form-field style="width:200px;">
                    <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
                </mat-form-field>
                &nbsp;&nbsp;
                <button type="submit" id="generateButtonSearch" (click)="generateCOCLetters()" mat-raised-button
                    color="primary" title="Generate COC Letters"
                    [disabled]='processing || dataSource.data == null || dataSource.data.length == 0'>Create Bulk
                    Generation/Download Job</button>
                <br />
                <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
                    style="overflow-x: auto;">
                    <mat-row>Results ({{retestService.searchResultsCount}}) </mat-row>
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                    <ng-container matColumnDef="selectRow">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="4" fxFlex.lt-sm="100"><input
                                id="selectAll" name="selectAll" type="checkbox" (click)="updateAll()"
                                [(ngModel)]="selectAll" /></mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex="4">
                            <input type="checkbox" [checked]="result.isSelected"
                                (change)="result.isSelected = !result.isSelected" />
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Id</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            {{result.id}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="wellId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header xFlex.lt-sm="100">Well Id</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            <span *ngIf="result.wellId == 0">&nbsp;</span>
                            <span *ngIf="result.wellId > 0">
                                <a [routerLink]="['/well/edit', result.wellId]"
                                    title="Edit Well {{result.wellId}}">{{result.wellId}}</a>
                            </span>
                        </mat-cell>
                    </ng-container>
                    
                    <ng-container matColumnDef="wellCounty">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Well County</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">

                            <span >{{result.wellCounty}}</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="orgininalSampleId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Original <br /> Sample
                            Id</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            <span *ngIf="result.householdId == 0">&nbsp;</span>
                            <span *ngIf="result.orgininalSampleId > 0">
                                <a href="javascript:void(0)" (click)="editSample(result.orgininalSampleId)"
                                    title="View Original Sample {{result.orgininalSampleId}}">{{result.orgininalSampleId}}</a>
                            </span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="retestSampleId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Retest <br /> Sample
                            Id</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            <span *ngIf="result.retestSampleId == 0">&nbsp;</span>
                            <span *ngIf="result.retestSampleId > 0">
                                <a href="javascript:void(0)" (click)="editSample(result.retestSampleId)"
                                    title="View Retest Sample {{result.retestSampleId}}">{{result.retestSampleId}}</a>
                            </span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="voucherIdentifier">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="12" fxFlex.lt-sm="100">Voucher <br />
                            Identifier</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex="12" fxFlex.lt-sm="100">
                            <span *ngIf="result.voucherId == 0">&nbsp;</span>
                            <span *ngIf="result.voucherId > 0">
                                <a href="javascript:void(0)" (click)="editVoucher(result.voucherId)"
                                    title="View Voucher Identifier {{result.voucherIdentifier}}">{{result.voucherIdentifier}}</a>
                            </span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="retestYear">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Year</mat-header-cell>
                        <mat-cell *matCellDef="let result">{{result.retestYear}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="retestQuarter">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Quarter</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            Q{{result.retestQuarter}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="tier">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Tier</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            Tier {{result.tier}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="dueDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Due Date</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            {{result.dueBy}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="isComplete">
                        <mat-header-cell *matHeaderCellDef mat-sort-header
                            fxFlex.lt-sm="100">Completed</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            <span *ngIf="result.isComplete == 'True'" class="success">Yes</span>
                            <span *ngIf="result.isComplete == 'False'" class="error">No</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="completedDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Completed
                            Date</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            {{result.completedDate}}
                        </mat-cell>
                    </ng-container>
                </mat-table>
                <br />
                <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator"
                    showFirstLastButtons></mat-paginator>
            </div>
        </mat-card>
    </mat-tab>
    <mat-tab label="Bulk Jobs">
        <div *ngIf="processingBulkJobs">
            <br /><br />
            <span>Loading Bulk Jobs...</span><br />
            <mat-progress-bar mode="query"></mat-progress-bar>
        </div>
        <div *ngIf="downloading">
            <br /><br />
            <span>Downloading...Don't close your browser or navigate away...this could take some time.</span><br />
            <mat-progress-bar mode="query"></mat-progress-bar>
        </div>
        <mat-card *ngIf="!processingBulkJobs && !downloading">
            <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                <strong class="noMarginHeader">Results ({{bulkJobs.length}}) </strong>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <mat-form-field style="width:200px;">
                    <input (keyup)="filterTableBulkJobs($event)" placeholder="Filter results" matInput />
                </mat-form-field>
                &nbsp;&nbsp;
                <a (click)="loadBulkJobs()"><mat-icon>refresh</mat-icon> </a>
                <br />
                <mat-table [dataSource]="dataSourceBulkJobs" matSort #TableSortBulkJobs="matSort"
                    class="mat-elevation-z8" style="overflow-x: auto;">
                    <mat-row>Results ({{bulkJobs.length}}) </mat-row>
                    <mat-header-row *matHeaderRowDef="displayedColumnsBulkJobs"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumnsBulkJobs;"></mat-row>
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Id</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            {{result.id}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="createDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header xFlex.lt-sm="100">Created</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            {{result.createDate}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="modifiyDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Last
                            Updated</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            {{result.modifiyDate}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="tier">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Tier</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">

                            <span *ngIf="result.tier > 0">{{result.tier}}</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="wellCounty">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Well County</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">

                            <span >{{result.wellCounty}}</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="year">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Year</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">

                            <span *ngIf="result.year > 0"> {{result.year}}</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="quarter">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Quarter</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">

                            <span *ngIf="result.quarter > 0">Q{{result.quarter}}</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="percentageComplete">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Percent
                            Complete</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                            {{result.percentageComplete}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="failed">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="12" fxFlex.lt-sm="100">Failed
                        </mat-header-cell>
                        <mat-cell *matCellDef="let result" fxFlex="12" fxFlex.lt-sm="100">
                            <span *ngIf="result.failed" class="text-red-400">Yes</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="message">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Message</mat-header-cell>
                        <mat-cell *matCellDef="let result">
                            <span style="white-space: pre-wrap">{{result.failedMessage}}{{result.comments}}</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Actions</mat-header-cell>
                        <mat-cell *matCellDef="let result">
                            <!-- Download -->
                            <span *ngIf="!result.failed && result.percentageComplete == 100">
                                <mat-icon matTooltip="Download Job"
                                    (click)="downloadJob(result.id, result.year, result.quarter, result.tier, result.wellCounty)">
                                    cloud_download
                                </mat-icon>
                            </span>&nbsp;&nbsp;
                            <!-- Delete -->
                            <span
                                *ngIf="result.percentageComplete == 100 && !authService.isReadOnly()"><mat-icon
                                    matTooltip="Delete Job" (click)="deleteBulkJob(result.id)">delete</mat-icon>
                                &nbsp;</span>
                        </mat-cell>
                    </ng-container>
                </mat-table>
                <br />
                <mat-paginator [pageSize]="pageSizeBulkJobs" [pageSizeOptions]="[10, 20, 50]"
                    #TablePaginatorBulkJobs="matPaginator" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card>
    </mat-tab>
</mat-tab-group>